import React, {useState} from 'react'
import {OutlookWrapper, OutlookNewEvent,} from '@rankmi/ats-app'
import { config } from '@frontend/constants/outlook_config'
import "./Outlook.scss"

const OutlookNew = ({ participant = "", appId=[], title="", description="" }) => {
    const [modal, setModal] = useState(false)

    return (
        <>
        {appId.length !==0 && 
            <OutlookWrapper config={ config }>
                <OutlookNewEvent 
                    text="Agendar reunión (Outlook)" 
                    className='button-outlook' 
                    participants={[participant]} 
                    modal={modal} 
                    setModal={setModal}
                    title={title}
                    description={description}
                />
            </OutlookWrapper>
        }
        </>
    )
}

export default OutlookNew